import { render, staticRenderFns } from "./LandingNavbar.vue?vue&type=template&id=18be4a32&scoped=true&"
import script from "./LandingNavbar.vue?vue&type=script&lang=js&"
export * from "./LandingNavbar.vue?vue&type=script&lang=js&"
import style0 from "./LandingNavbar.vue?vue&type=style&index=0&id=18be4a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18be4a32",
  null
  
)

export default component.exports